// Round avatar. Shows the user's Google photo when available, else colored
// initials. color/ink come from the user's profile doc.
export default function Avatar({ user, size = 24, style, title, onClick }) {
  const base = avatarStyle(user?.color || '#7A7568', user?.ink || '#F4EFE6', size)
  if (user?.photoURL) {
    return (
      <img
        src={user.photoURL}
        alt={user?.name || ''}
        referrerPolicy="no-referrer"
        onClick={onClick}
        title={title ?? user?.name}
        style={{ ...base, objectFit: 'cover', ...style }}
      />
    )
  }
  return (
    <div onClick={onClick} title={title ?? user?.name} style={{ ...base, ...style }}>
      {user?.initials || '?'}
    </div>
  )
}

/** Round avatar style — color/ink come from the user's profile doc.
 * Inlined copy of src/lib/format.js's avatarStyle: the kit must not depend
 * on app modules, so this is a deliberate small duplication. */
function avatarStyle(color, ink, size) {
  return {
    width: size,
    height: size,
    borderRadius: '50%',
    background: color,
    color: ink,
    fontSize: Math.round(size * 0.4),
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    letterSpacing: '.02em',
    fontFamily: 'var(--font-sans)',
    border: 'none',
    cursor: 'default',
  }
}
